export const DAY_DISABLED = 'disabled';
export const DAY_ENABLED = 'enabled';
export const DAY_SELECTED = 'selected';
